module.exports = __webpack_public_path__ + "img/login-bg.828419b5.png";